"use strict";
/*
 * Created on 19. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * User info converter.
 *
 * @author Radek Beran
 */


var UserInfoConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(UserInfoConverter, _DataObjectConverter_);

  function UserInfoConverter() {
    _classCallCheck(this, UserInfoConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserInfoConverter).apply(this, arguments));
  }

  return UserInfoConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.UserInfoConverter = UserInfoConverter;